import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Merge Detail|Unmerge Request Dialog|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityMergeUnmergeRequestDialog';
export type SPCandidateSystemActivityMergeUnmergeRequestDialogLocNames =
	| `${LocNameStart}TitleCompleteUnmerge`
	| `${LocNameStart}LabelUnmergeComments`
	| `${LocNameStart}ErrorUnmergeCommentsRequired`
	| `${LocNameStart}ButtonUnmergeSubmit`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}WarningMessage`;

export const spCandidateSystemActivityMergeUnmergeRequestDialogLocs: LocDefs<SPCandidateSystemActivityMergeUnmergeRequestDialogLocNames> =
	{
		SPCandidateSystemActivityMergeUnmergeRequestDialogTitleCompleteUnmerge: {
			defaultValue: 'Complete Unmerge',
			description: 'Complete Unmerge title',
			displayPath: `${pathStart}Complete Unmerge`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeUnmergeRequestDialogLabelUnmergeComments: {
			defaultValue: 'Comments',
			description: 'Label for: Comments.',
			displayPath: `${pathStart}Comments`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.FieldLabel.UnmergeComments',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeUnmergeRequestDialogErrorUnmergeCommentsRequired: {
			defaultValue: 'Comments are required',
			description: 'Error for: Comments are required.',
			displayPath: `${pathStart}Comments are required`,
			displayType: 'Error',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.FieldError.UnmergeCommentsRequired',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeUnmergeRequestDialogButtonUnmergeSubmit: {
			defaultValue: 'Complete Unmerge',
			description: 'Complete Unmerge Button',
			displayPath: `${pathStart}Complete Unmerge Button`,
			displayType: 'Button',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.Button.UnmergeSubmit',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeUnmergeRequestDialogButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel Button',
			displayPath: `${pathStart}Cancel Button`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeUnmergeRequestDialogWarningMessage: {
			defaultValue:
				'Warning. There are more recent merges for the candidate you are trying to unmerge. If you are trying to undo an incorrect merge, please make sure you do not need to unmerge the most recent merge before unmerging this one.',
			description: 'Warning message',
			displayPath: `${pathStart}Warning Message`,
			displayType: 'Content',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityMergeUnmergeRequestDialogLocType =
	LocMap<SPCandidateSystemActivityMergeUnmergeRequestDialogLocNames>;
